<template>
	<sf-data-table
		ref="RtnPartMstTable"
		paging
		index
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="cmpnMstCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		creatable
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RtnPartMst/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.rtnPartMstList;
		},
		cmpnMstCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001245'), //Ro No
					prop: 'roNo',
					width: '200px',
					align: 'center',
					highlight: true,
					clickEvent: this.openModal
				},
				{
					label: this.getMessage_('QWCC001538'), // PMC Id
					prop: 'pmcId',
					headerAlign: 'center',
					width: '200px'
				},
				// {
				// 	label: this.getMessage_('QWCC001174'), // R/O 확정일
				// 	prop: 'dcsnDd',
				// 	width: '150px',
				// 	sortable: true
				// },
				// {
				// 	label: this.getMessage_('QWCC001225'), // 클레임 No
				// 	prop: 'clmNo',
				// 	width: '150px'
				// },
				// {
				// 	label: this.getMessage_('QWCC001226'), // 클레임 확정일
				// 	prop: 'clmDcsnDd',
				// 	width: '150px',
				//
				// },
				{
					label: this.getMessage_('QWCC001229'), // 고품상태
					prop: 'rptpStNm',
					align: 'center',
					width: '100px'
				},
				{
					label: this.getMessage_('QWCC001140'), // 품번(원인부품번호)
					prop: 'causPartNo',
					headerAlign: 'center',
					width: '150px'
				},
				{
					label: this.getMessage_('QWCC000957'), // 품명(원인부품번호)
					prop: 'causPartNm',
					headerAlign: 'center',
					width: '300px'
				},
				{
					label: this.getMessage_('QWCC000960'), // 차량 VIN
					prop: 'carVin',
					headerAlign: 'center',
					width: '200px'
				},
				{
					label: this.getMessage_('QWCC000959'), // 딜러점
					prop: 'dlrCpnyNm',
					align: 'center',
					width: '100px'
				},
				{
					label: this.getMessage_('QWCC001906'), // 회수방법
					prop: 'clctWayNm',
					align: 'center',
					width: '100px'
				},

				{
					label: this.getMessage_('QWCC001251'), // 신청자
					prop: 'aplcNm',
					align: 'center',
					width: '100px'
				},
				{
					label: this.getMessage_('QWCC001257'), // 수신자
					prop: 'rcptNm',
					headerAlign: 'center',
					width: '150px'
				},
				{
					label: this.getMessage_('QWCC001263'), // 발신자
					prop: 'dsprNm',
					headerAlign: 'center',
					width: '150px'
				},
				{
					label: this.getMessage_('QWCC001905'), // 회수자
					prop: 'clctNm',
					headerAlign: 'center',
					width: '150px'
				},
				{
					label: this.getMessage_('QWCC001230'), // 택배번호
					prop: 'dlvsNo',
					headerAlign: 'center',
					width: '150px'
				},
				{
					label: this.getMessage_('QWCC001231'), // 확인완료일
					prop: 'cmplDd',
					align: 'center',
					width: '200px'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		openModal(row) {
			// 고품회수등록 상세 팝업 호출
			const param = {
				title: this.getMessage_('QWCC001792'),
				roNo: row.roNo
			};
			this.$emit('registerRtnPart', param);
		}
	}
};
</script>

<style></style>
